<template>
  <v-container class="page-content px-5" style="width: 100%">
    <div v-if="loading === false">
      <v-row no-gutters class="justify-center">
        <v-icon
            v-if="accept"
            size="250"
            color="green"
        >check_circle_outline</v-icon>
        <v-icon
            v-else
            size="250"
            color="red"
        >error</v-icon>
      </v-row>
      <v-row no-gutters class="justify-center text-h5 text-md-h4 mt-6 font-weight-bold">
        <span v-if="accept"> Ваш чат был подтвержден!</span>
        <span v-else>{{ this.errors.chat_id }}</span>
      </v-row>
      <v-row no-gutters class="justify-center mt-10">
        <v-btn
            color="primary"
            elevation="4"
            x-large
            rounded
            @click="returnToMain()"
        >
          На главную
        </v-btn>
      </v-row>
    </div>

    <div class="action mt-16 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import {SemipolarSpinner} from "epic-spinners";
import names from "@/modules/entitled/routers/names";

export default {
  name: "ChatApprove",
  components: {
    SemipolarSpinner
  },
  data() {
    return {
      loading: true,
      accept: false,
      errors: ""
    }
  },
  methods: {
    ...mapActions({
      chatApprove: "entitled/chatApprove"
    }),
    sendRequest() {
      this.chatApprove({
        gets: {chat_id: this.$route.query.chat_id},
        finalizer: (val) => {
          this.accept = true
          this.loading = false
        },
        catcher: (val) => {
          this.errors = val
          this.loading = false
        }
      })
    },
    returnToMain() {
      this.$router.push({name: names.ORDERS.LIST}).catch(() => {}).catch(() => {})
    }
  },
  created() {
    this.sendRequest()
  }
}
</script>

<style scoped>

</style>
